import { render, staticRenderFns } from "./positivity_rate_table.vue?vue&type=template&id=56abd5fc&"
import script from "./positivity_rate_table.vue?vue&type=script&lang=js&"
export * from "./positivity_rate_table.vue?vue&type=script&lang=js&"
import style0 from "./positivity_rate_table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports